import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { Panel } from 'react-bootstrap';

import './styles.scss';

export default function ApexCard({
  children,
  className,
  controls,
  fullWidth,
  label,
  labelControls,
  overflowAuto,
  required,
  verticalBody
}) {
  return (
    <Panel className={classNames('apex-card', className, { 'full-width': fullWidth, 'panel-required': required })}>
      {label &&
        <Panel.Heading>
          <div className="d-flex flex-row">
            <h3 className="apex-card-title m-0 mr-3">
              {label}
            </h3>
            {labelControls && <div>{labelControls}</div>}
          </div>

          <div>
            {controls}
          </div>
        </Panel.Heading>
      }

      <Panel.Body className={classNames('d-flex', { 'flex-column': verticalBody, 'overflow-auto': overflowAuto })}>
        {children}
      </Panel.Body>
    </Panel>
  );
}

ApexCard.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  controls: PropTypes.node,
  fullWidth: PropTypes.bool,
  label: PropTypes.string,
  labelControls: PropTypes.node,
  overflowAuto: PropTypes.bool,
  required: PropTypes.bool,
  verticalBody: PropTypes.bool,
};
